import ListItem from "../../../components/ListItem";
import React, { useState } from "react";
import { $ } from "../../../../../vendor";

const AdminTransactionListItem = (props) => {
  const currentUrl = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  const toggleElement = (ev, key) => {
    console.log("key", key);
    $("#wallet-transactions-item-" + key).toggleClass("toggled");
    $("#row-" + key).toggleClass("toggled");
    if ($("#wallet-transactions-item-" + key).hasClass("toggled")) {
      searchParams.set("item", key);
    } else {
      searchParams.delete("item");
    }

    const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
    history.pushState(null, "", newRelativePathQuery);
  };

  return (
    <>
      <ListItem
        key={props.key}
        listStyle={props.listStyle}
        id={props.id}
        overwriteClasses={props.overwriteClasses}
        elements={props.elements}
        menu={props.menu}
        refLink={props.refLink}
        length={props.length}
        extra5={true}
        toggleElement={toggleElement}
        multipleCheckins={true}
        wallet={props.wallet}
        dispatch={props.dispatch}
        app_user_role={props.app_user_role}
        setId={true}
        setFilter={props.setFilter}
        filter={props.filter}
        setNKey={props.setNKey}
        sort={props.sort}
        setSort={props.setSort}
      />
    </>
  );
};

export default AdminTransactionListItem;
